module.exports = __webpack_public_path__ + "static/img/Diamond1.8ec84c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Diamond1.svg
// module id = yak7
// module chunks = 35